import { useContext } from 'react';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { Container, LabelContent, PreLabel } from './TootipSearchLabel.styled';

function TootipSearchLabel() {
	const { globalization }: any = useContext(CruiseSearchContext);

	const { dictionaries = {} } = globalization || {};
	const { generalDictionary = {} } = dictionaries || {};
	const { labelNLSPoweredBy = '' } = generalDictionary;
	const lastWord = 'AISearch';
	const preWord = labelNLSPoweredBy.replace(lastWord, '').trim();

	return (
		<Container>
			<PreLabel>{preWord}</PreLabel> <LabelContent>{lastWord}</LabelContent>
		</Container>
	);
}

export default TootipSearchLabel;
